import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import i18n from "../../i18n";

const WhatWeDoScreen: React.FC = () => {
  const { t, language } = i18n;
  const langPrefix = getUrlLangPrefix();

  return (
    <Container
      fluid
      className="screenContainer p-0 pt-4 pt-lg-0"
      style={{ backgroundColor: "var(--screen-bg-color)" }}
    >
      <Container className="flexContainer pakvertContainer">
        <Row className="w-100 pt-2 pb-2">
          <Col lg={6} xs={12}>
            <div className="flexContainer" style={{ gap: "8px" }}>
              <h2>{t("What We Do")}</h2>
              <p>
                {t(
                  "PakVille designs and manufactures next-generation modular buildings using its proprietary PakVert engineered panels, made from 100% recycled materials. These all-in-one panels replace traditional framing, insulation, vapor barriers, drywall, and exterior sheathing, making construction faster, affordable, and sustainable.",
                )}
              </p>
              <NavLink to={`${langPrefix}/${t("_route.the-technology")}`}>
                <Button className="btn-primary">{t("learn_more")}</Button>
              </NavLink>
            </div>
          </Col>

          <Col lg={6} xs={12}>
            <div className="flexContainer">
              <AnimationOnScroll
                animateOnce
                animateIn="animate__fadeInRightBig"
              >
                <Image
                  rounded
                  alt={t("What We Do")}
                  className="mw-100 aspectImg aspectImg--4x3"
                  loading="lazy"
                  src={`/images/home/PakVert_Technology_Patent_${language}.png`}
                />
              </AnimationOnScroll>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default WhatWeDoScreen;
